import React from 'react';
import { Mask } from './mask';

const Header: React.FC = ({ children }) => {
    return (
        <div className="p-editor__header">
            {children}
            <Mask type="header" />
        </div>
    );
};

export default Header;
